import React, { useState, useEffect } from 'react';
import './RankingPanel.css'; // 复用排行榜的样式

const FavoritesPanel = ({ onMarkersUpdate, selectedResort, onResortSelect }) => {
  const [favorites, setFavorites] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadFavorites = async () => {
      try {
        setLoading(true);
        const storedFavorites = JSON.parse(localStorage.getItem('favorites') || '[]');
        
        if (storedFavorites.length > 0) {
          // 修正 API URL
          const resortsData = await Promise.all(
            storedFavorites.map(fav => 
              fetch(`/resort/${fav.id}?source=web`).then(res => res.json())
            )
          );

          // 添加收藏时间
          const resortsWithTimestamp = resortsData.map((resort, index) => ({
            ...resort,
            timestamp: storedFavorites[index].timestamp
          }));

          // 按收藏时间倒序排序
          const sortedResorts = resortsWithTimestamp.sort((a, b) => b.timestamp - a.timestamp);
          
          setFavorites(sortedResorts);
          
          // 更新地图标记
          const markers = sortedResorts.map(resort => ({
            id: resort.id,
            longitude: resort.longitude,
            latitude: resort.latitude,
            isSelected: selectedResort?.id === resort.id,
            isFavorite: true,
            popup: `
              <div class="resort-popup">
                <h3>${resort.name}</h3>
                <p>${resort.country}${resort.region ? ` · ${resort.region}` : ''}</p>
                <p class="favorite-marker">已收藏</p>
              </div>
            `
          }));
          
          onMarkersUpdate(markers);
        } else {
          setFavorites([]);
          onMarkersUpdate([]);
        }
        setError(null);
      } catch (error) {
        console.error('Failed to load favorites:', error);
        setError('加载收藏失败');
      } finally {
        setLoading(false);
      }
    };

    loadFavorites();
  }, [selectedResort, onMarkersUpdate]);

  // 处理滑雪场点击
  const handleResortClick = async (resort) => {
    try {
      // 获取完整的度假村详情
      const detail = await fetch(`/resort/${resort.id}?source=web`).then(res => res.json());
      
      onResortSelect(detail);
    } catch (error) {
      console.error('获取度假村详情失败', error);
    }
  };

  // 处理取消收藏
  const handleRemoveFavorite = (e, resortId) => {
    e.stopPropagation();
    const favorites = JSON.parse(localStorage.getItem('favorites') || '[]');
    const newFavorites = favorites.filter(fav => fav.id !== resortId);
    localStorage.setItem('favorites', JSON.stringify(newFavorites));
    setFavorites(prev => prev.filter(resort => resort.id !== resortId));
  };

  // 添加导出功能
  const handleExportFavorites = () => {
    const favoritesData = favorites.map(resort => ({
      id: resort.id,
      name: resort.name,
      timestamp: resort.timestamp
    }));
    
    const blob = new Blob([JSON.stringify(favoritesData, null, 2)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'ski_resort_favorites.json';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  // 添加清空收藏功能
  const handleClearAllFavorites = () => {
    if (window.confirm('确定要删除所有收藏吗？')) {
      localStorage.setItem('favorites', '[]');
      setFavorites([]);
      onMarkersUpdate([]);
    }
  };

  return (
    <div className="ranking-panel">
      <div className="favorites-header">
        <h2>我的收藏</h2>
        <div className="favorites-header-right">
          <span className="favorite-count-large">{favorites.length}</span>
          {favorites.length > 0 && (
            <>
              <button 
                className="export-btn"
                onClick={handleExportFavorites}
              >
                导出收藏
              </button>
              <button 
                className="clear-all-btn"
                onClick={handleClearAllFavorites}
              >
                删除所有
              </button>
            </>
          )}
        </div>
      </div>

      {loading && (
        <div className="loading">
          加载中...
        </div>
      )}

      {error && (
        <div className="error-message">
          {error}
        </div>
      )}

      {!loading && !error && favorites.length === 0 && (
        <div className="empty-state">
          <p>还没有收藏任何滑雪场</p>
          <p>点击滑雪场详情中的收藏按钮来添加收藏</p>
        </div>
      )}

      {!loading && !error && favorites.length > 0 && (
        <div className="ranking-list">
          {favorites.map((resort) => (
            <div 
              key={resort.id} 
              className={`list-item ${selectedResort?.id === resort.id ? 'selected' : ''}`}
              onClick={() => handleResortClick(resort)}
            >
              <div className="col-resort">
                <div className="resort-title">
                  <span className="resort-name">{resort.name}</span>
                  <span className="resort-location">
                    {resort.country}{resort.region ? ` · ${resort.region}` : ''}
                  </span>
                </div>
                <span className="resort-details">
                  {`评分${resort.rating} | 总长${resort.totalTrails}km | 落差${resort.verticalDrop}m`}
                </span>
              </div>
              <button 
                className="remove-favorite-btn"
                onClick={(e) => handleRemoveFavorite(e, resort.id)}
              >
                取消收藏
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default FavoritesPanel; 